import { GsbApiService as SharedApiService, GsbHttpError, } from "@gsb-core/client/internal";
import { coreHttpParsers } from "./core-http-protocol.js";
export { GsbHttpError, isInvalidSessionCode, } from "@gsb-core/client/internal";
GsbHttpError.composeProtocolValidation(coreHttpParsers);
export class GsbApiService extends SharedApiService {
    constructor() {
        super();
        this.composeProtocolValidation(coreHttpParsers);
    }
    static getInstance() {
        const instance = super.getInstance();
        instance.composeProtocolValidation(coreHttpParsers);
        return instance;
    }
}
//# sourceMappingURL=core-api.service.js.map